// Locale set. tr is the default and stays on unprefixed routes; az is served
// under /az/*. Adding en/de later = extend this list + a messages/<locale>.json.
export const locales = ["tr", "az"] as const;
export type Locale = (typeof locales)[number];
export const defaultLocale: Locale = "tr";

export function isLocale(value: string | undefined): value is Locale {
    return !!value && (locales as readonly string[]).includes(value);
}
